import { render, staticRenderFns } from "./advertisingConfig.vue?vue&type=template&id=6a5bc93a&"
import script from "./advertisingConfig.vue?vue&type=script&lang=js&"
export * from "./advertisingConfig.vue?vue&type=script&lang=js&"
import style0 from "./advertisingConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports